import { render } from "./import-button.vue?vue&type=template&id=4b567103&ts=true"
import script from "./import-button.vue?vue&type=script&lang=ts"
export * from "./import-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__